import { DashboardStorage } from '@/pages/DashboardStorage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/storage')({
  component: DashboardStorage,
  meta: () => [{ title: 'Storage' }],
})
